import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const COPY = {
  beginning: {
    title: "Beginning Inventory Required",
    message:
      "The beginning inventory for today has not been completed yet. Please count and enter the available stock before store operations continue.",
    start: "Start Beginning Inventory",
    later: "Remind Me Later",
  },
  ending: {
    title: "Complete Ending Inventory",
    message:
      "The Z-reading has been completed. Please count the remaining physical stock and record today's ending inventory.",
    start: "Start Ending Inventory",
    later: "Do It Later",
  },
};

const InventoryReminderDialog = ({ open, mode, onStart, onLater }) => {
  const copy = COPY[mode] || COPY.beginning;
  return (
    <Dialog
      open={open}
      onClose={onLater}
      fullWidth
      maxWidth="sm"
      hideBackdrop
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
      disableScrollLock
      aria-labelledby="inventory-reminder-title"
      aria-describedby="inventory-reminder-description"
      sx={{
        pointerEvents: "none",
      }}
      PaperProps={{
        "aria-modal": false,
        sx: {
          pointerEvents: "auto",
          border: 1,
          borderColor: "divider",
          boxShadow: 12,
        },
      }}
    >
      <DialogTitle id="inventory-reminder-title">{copy.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="inventory-reminder-description">
          {copy.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, flexWrap: "wrap" }}>
        <Button onClick={onLater}>{copy.later}</Button>
        <Button variant="contained" onClick={onStart}>
          {copy.start}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InventoryReminderDialog;
